const TimelineCompressionsAndVentilations = ({
  compressionsData,
  ventilationsData,
  startTime,
  endTime,
}) => {
  const totalDuration = endTime - startTime;

  const barHeight = 8;

  const colorCompressions = "#228C80";
  const colorVentilations = "#F9839A";

  const getLeftWidth = (start, stop) => {
    const left = ((start - startTime) / totalDuration) * 100;
    const width = ((stop - start) / totalDuration) * 100;
    return { left, width };
  };

  return (
    <div
      style={{
        display:'flex',
        width: "100%",
        height: "100%",
        alignItems:'center'
      }}
    >
      <div  style={{
        position: "relative",
        width: "100%",
      }}>
        {/* Compressions (top track) */}
        {compressionsData?.map((item, index) => {
          const { left, width } = getLeftWidth(item.start, item.stop);
          return (
            <div
              key={`compression-${index}`}
              style={{
                position: "absolute",
                bottom: 0,
                left: `${left}%`,
                width: `${width}%`,
                height: `${barHeight}px`,
                backgroundColor: colorCompressions,
                borderRadius: "3px",
              }}
            />
          );
        })}

        {/* Ventilations (bottom track) */}
        {ventilationsData?.map((item, index) => {
          const { left, width } = getLeftWidth(item.start, item.stop);
          return (
            <div
              key={`ventilation-${index}`}
              style={{
                position: "absolute",
                top: 0,
                left: `${left}%`,
                width: `${width}%`,
                height: `${barHeight}px`,
                backgroundColor: colorVentilations,
                borderRadius: "3px",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TimelineCompressionsAndVentilations;
